module.exports = __webpack_public_path__ + "img/ct-orientation.fea7b9bc.png";